module.exports = __webpack_public_path__ + "media/src/assets/images/a-e158a23e5b2714f9202cee40f92a3b03.png";